import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element'
import './styles/index.scss'
import './router/permission'
import dialogDragResize from './directives/dialogDragResize'

// el-dialog 拖拽缩放全局指令
Vue.directive('dialog-drag-resize', dialogDragResize)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
